/**
 * A global namespace for `keydown` event.
 * @type {string}
 */
const keydownEvent = 'keydown';
export default keydownEvent;
